import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  HitRelatedResource,
  ShowcaseData,
  ShowcasesRequestParams,
  ShowcasesResponse,
  ShowcasesTypes,
  SingleShowcaseRequestParams,
  MultipleShowcaseRequestParams,
} from '../models/showcases';

@Injectable({
  providedIn: 'root',
})
export class ShowcasesService {

  private static readonly showcaseUrl = 'api/search-result/showcases';

  constructor(
    private http: HttpClient,
  ) { }

  public getAllShowcases(queryParams: ShowcasesRequestParams) {
    const params = {
      id: queryParams.id,
      entityType: queryParams.entityType,
      targetType: queryParams.targetType,
    };
    return this.http.get<ShowcasesResponse>(`${ShowcasesService.showcaseUrl}`, {params});
  }

  public getMultipleShowcase(showcaseType: ShowcasesTypes, params: MultipleShowcaseRequestParams) {
    const url = `${ShowcasesService.showcaseUrl}/${showcaseType}`;
    const requestParams = {
      id: params.id,
      entityType: params.entityType,
      pageNum: params.pageNum + '',
      pageSize: params.pageSize + '',
      targetType: params.targetType,
    } as any;
    if (params.showcaseId) {
      requestParams.showcaseId = params.showcaseId;
    }
    return this.http.get<ShowcaseData>(url, {params: requestParams});
  }

  public getSingleShowcase(params: SingleShowcaseRequestParams) {
    const url = `${ShowcasesService.showcaseUrl}/${params.showcase}/resources/${params.identifier}`;
    const requestParams = {
      id: params.id,
      entityType: params.entityType,
      pageNum: params.pageNum + '',
      pageSize: params.pageSize + '',
      targetType: params.targetType,
    } as any;
    if (params.showcaseId) {
      requestParams.showcaseId = params.showcaseId;
    }
    return this.http.get<HitRelatedResource>(url, {params: requestParams});
  }
}
